var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CategoriesForm',{attrs:{"is-new":false,"heading":"Edit category","api-base":"product-categories","url-base":"/products/categories"}})}
var staticRenderFns = []

export { render, staticRenderFns }